import styled, { css } from 'styled-components';
import { getTypographyStyles } from '../../utils/index.js';
import { SYS_SIZE_FIXED_50 } from '../../tokens/sizing.generated.js';
import { typographyTokenMapping } from '../../utils/get-typography-styles/tokens/index.js';
export const StyledText = styled.div `
  margin: 0;
  color: ${(props) => props.theme.global.color.typography.copy.default};

  ${(props) => {
    const { type, order, style } = props.variant;
    return css `
      ${getTypographyStyles(typographyTokenMapping.sys.typography[type]['order'][order][style])}
    `;
}};

  sup {
    vertical-align: 0.68em;
  }

  sub {
    vertical-align: -0.275em;
  }

  sup,
  sub {
    font-size: 0.583em;

    a {
      color: inherit;
      text-decoration: none;
      border-bottom: ${SYS_SIZE_FIXED_50} solid
        ${(props) => props.theme.cmp.color.navigation.textLink.foreground.default};

      transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
      transition-duration: 250ms;
      transition-property: color, border-color;

      &:hover {
        color: ${(props) => props.theme.cmp.color.navigation.textLink.foreground.interactive};
        border-bottom-color: ${(props) => props.theme.cmp.color.navigation.textLink.foreground.interactive};
      }
      border-bottom: none;
    }
  }
`;
//# sourceMappingURL=index.styles.js.map